<template>
  <div>
    <div class="column is-12">
      <h2 class="title">¿Qué producto desea comprar?</h2>
    </div>
    <div class="column is-12">
      <option-select :options="stepOptions" @select="onSelect"/>
    </div>
  </div>
</template>

<script>

const options = [
  {
    label: 'Telas',
    value: 'fabrics',
    component: 'IsCustomerAlready'
  },
  {
    label: 'Productos terminados',
    value: 'finished_products',
    component: 'FinishedProductFlow'
  },
  {
    label: 'Servicio al cliente y garantías',
    value: 'customer_service',
    component: 'CustomerServiceFlow'
  }
];

export default {
  name: 'QuestionnaireStart',
  computed: {
    stepOptions() {
      return options;
    }
  },
  methods: {
    onSelect(option) {
      this.$emit('done', {
        key: 'productType',
        selectedOption: option
      });
    }
  }
}
</script>
